import { Input as AntInput } from 'antd';
import styled, { css } from 'styled-components';

import { Select } from '@style/global-style.app';

const COMMON_INPUT_STYLE = css`
  padding: 8px 12px;
  font-size: 14px;

  &::placeholder {
    font-size: inherit;
  }
`;

export const StyledInput = styled(AntInput)`
  ${COMMON_INPUT_STYLE}
`;

export const StyledTextArea = styled(AntInput.TextArea)`
  ${COMMON_INPUT_STYLE}
`;

export const StyledPasswordInput = styled(AntInput.Password)`
  ${COMMON_INPUT_STYLE}
`;

export const StyledTagInput = styled(Select).attrs({
  suffixIcon: null,
})`
  ${COMMON_INPUT_STYLE}
  & .ant-select-selection-wrap {
    margin-top: 6px;
  }
`;
